export default {
  businessType: '业务类型',
  grDate: '日期',
  reworkDate: '复检日期',
  cartonPe: '箱 PE',
  asn: 'ASN',
  plant: '仓库',
  asnNumber: 'ASN#',
  po: 'PO#',
  poItem: 'PO-item#',
  cartonNo: '箱号',
  sku: 'SKU (颜色+尺码)',
  asnQty: 'ASN件数',
  reworkType: '复检类型',
  reworkLt: '复检周期',
  relabelUnit: '补标 (件)',
  noRfidTagQtyUnit: 'RFID缺失 (件)',
  scanNoResponseQtyUnit: 'RFID读取无反应 (件)',
  multipleRfidCartonQtyUnit: '多标 (件)',
  physicalSkuCorrectQtyUnit: '错标 (件)',
  physicalSkuIncorrectQtyUnit: '实物错误 (件)',
  productName: '产品名称',
  singleMultipleUpc: '单/多UPC',
  factory: '工厂',
  lpnSize: 'LPN Size',
  nfcSku: 'NFC SKU',
  wrongPhysicalProduct: '实物错误产品',
  wrongEpc: '错标EPC',
  multipleEpc: '多标EPC',
  upc: 'UPC',
  skuColor: 'SKU(颜色)'
}
